<template>
  <v-app>
    <v-container v-show="loading" fluid :style="backgroundPartner">
      <v-layout align-center justify-center fill-height>
        <v-card light class="card-loading">
          <v-card-text>
            <v-flex mb-4>
              <v-progress-circular
                :size="80"
                :width="6"
                color="light-blue accent-4"
                indeterminate
              />
            </v-flex>
            <span>Loading ...</span>
          </v-card-text>
          <v-card-text>
            <h6 v-if="external_access && checkToken">
              Vertify Token ...
              <span v-if="checkToken" style="color: #00BFA5;">Success</span>
            </h6>
            <h6 v-if="external_access && checkToken">
              Authentication ...
              <span v-if="checkAuth" style="color: #00BFA5;">Success</span>
            </h6>
            <h6 v-if="redirect">Redirect in {{ coundown }} seconds</h6>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
    <v-container
      v-show="!loading"
      fluid
      class="container-login"
      :style="backgroundPartner"
    >
      <v-layout class="box-layout">
        <v-flex class="box-overview">
          <img class="logo-ilog" :src="logo" alt="ilog-logo" />
          <img
            class="logo-ilog"
            v-if="logoPartner"
            :src="logoPartner"
            :style="stylelogoPartner"
            alt="ilog-logopartner"
          />
          <h2 class="text-trans">
            Welcome to iLog Platform <br />
            log analytic on cloud
          </h2>
          <img :src="image_info" :style="style_img_info" alt="image-view" />
        </v-flex>
        <v-flex class="box-login" :style="style_right">
          <h2 v-if="!forgotPassword" id="headersignin">Sign In</h2>
          <h2 v-else>Reset Password</h2>
          <v-form v-if="!forgotPassword">
            <v-card class="card login-trans" light>
              <v-card-text>
                <v-flex
                  v-if="statelogin"
                  id="username-login"
                  style="margin-top:64px !important;"
                  lg10
                  md10
                  sm10
                  xs10
                  offset-lg1
                  mt-5
                  offset-md3
                  offset-sm3
                  offset-xs3
                  row
                >
                  <div class="tab-left"></div>
                  <v-icon size="25" class="icon_person">person_outline</v-icon>
                  <v-text-field
                    v-model="username"
                    id="username"
                    label="Username"
                    color="light-blue"
                    placeholder="Enter your username or e-mail here"
                    browser-autocomplete="username email"
                    @keyup.enter="login"
                    autofocus
                    clearable
                    required
                    dark
                  />
                  <div class="tab-right"></div>
                </v-flex>
                <v-flex v-else column>
                  <v-flex
                    lg10
                    md10
                    sm10
                    xs10
                    offset-lg1
                    offset-md3
                    offset-sm3
                    offset-xs3
                    row
                    style="position:relative; top:5px;"
                  >
                    <v-card class="usernamestate2" dark>
                      <v-card-title class="text-center">
                        <v-icon size="21" class="icon_person" center
                          >person_outline</v-icon
                        >
                        <span>{{ username }}</span>
                      </v-card-title>
                    </v-card>
                    <v-spacer />
                    <v-btn
                      color="#44465B"
                      dark
                      style="outline: none;"
                      @click="backToEmail"
                    >
                      <v-icon dark class="back_login">
                        arrow_back_ios_new
                      </v-icon>
                      <span
                        style="text-transform: none !important; color: #DADADA !important;"
                        >Back</span
                      >
                    </v-btn>
                  </v-flex>
                  <v-flex
                    lg10
                    md10
                    sm10
                    xs10
                    offset-lg1
                    mt-3
                    offset-md3
                    offset-sm3
                    offset-xs3
                    id="username-login"
                    row
                  >
                    <div class="tab-left"></div>
                    <v-icon size="25" class="icon_person">lock</v-icon>
                    <v-text-field
                      v-model="password"
                      label="Password"
                      id="password"
                      browser-autocomplete="password"
                      color="light-blue"
                      placeholder="Enter your password here"
                      autofocus
                      required
                      :append-icon="
                        showPassword ? 'visibility' : 'visibility_off'
                      "
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      @keyup.native.enter="login"
                      dark
                    />
                    <div class="tab-right"></div>
                  </v-flex>
                </v-flex>
                <v-flex v-if="logonFailure" class="fail-login">
                  <h2 style="color: #F44336; font-size:14px;">
                    {{ logonFailureText }}
                  </h2>
                </v-flex>
                <v-flex row mt-2 class="session-box">
                  <v-flex class="timesession">
                    <v-select
                      v-model="timetoken"
                      :items="timesession"
                      label="Session Login"
                      attach
                      dark
                      color="light-blue"
                    />
                  </v-flex>
                  <v-flex mt-3 class="forgotPW">
                    <v-btn
                      flat
                      round
                      small
                      color="light-blue"
                      style="text-transform: none !important; outline:none !important;"
                      @click="resetPw"
                    >
                      Forgot Password ?
                    </v-btn>
                  </v-flex>
                </v-flex>
                <v-flex mx-4 px-3>
                  <v-btn
                    round
                    block
                    :color="buttonColor"
                    dark
                    :loading="loadingBtn"
                    @click="login"
                    style="outline:none !important;"
                    class="font-weight-normal btn-ilog-login"
                  >
                    <span v-if="statelogin">Next</span>
                    <span v-else>Sign In</span>
                  </v-btn>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-form>
          <v-form v-else @keyup.native.enter="login">
            <v-card class="card" light>
              <v-card-text>
                <v-flex
                  id="username-login"
                  style="margin-top:64px !important;"
                  lg10
                  md10
                  sm10
                  xs10
                  offset-lg1
                  mt-5
                  offset-md3
                  offset-sm3
                  offset-xs3
                  row
                >
                  <div class="tab-left"></div>
                  <v-icon size="25" class="icon_person">restart_alt</v-icon>
                  <v-text-field
                    v-model="username"
                    id="username"
                    label="Reset Password"
                    color="light-blue"
                    placeholder="Enter your e-mail here"
                    @keyup.enter="resetPassword"
                    autofocus
                    clearable
                    required
                    dark
                  />
                  <div class="tab-right"></div>
                </v-flex>
                <v-flex mt-5 class="groupResetPW">
                  <v-btn
                    round
                    :color="buttonColor"
                    dark
                    @click="resetPassword"
                    style="outline:none !important;"
                    class="font-weight-normal"
                  >
                    Reset Password
                  </v-btn>

                  <v-btn
                    round
                    color="red"
                    dark
                    @click="
                      forgotPassword = false;
                      (ResetFailure = false), (username = '');
                    "
                    style="outline:none !important;"
                    class="font-weight-normal"
                  >
                    Cancel
                  </v-btn>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-form>
          <v-layout class="info-bottom">
            <v-flex text-lg-left class="version">
              <span>@iLog Version 2.6</span>
            </v-flex>
            <v-spacer />
            <v-flex text-lg-right style="color: #BBB; font-size: 12px; ">
              <span style="pointer-events: none;">Powered by</span>
              <a href="https://ragnar.co.th/" target="_blank" rel="noopener">
                <img
                  class="logo-ragnar"
                  :src="require('../assets/img/login/RG-Corporation-2.png')"
                  alt="rg-logo"
                />
              </a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :left="false"
        :multi-line="true"
        :right="false"
        :timeout="6000"
        :top="true"
        :vertical="false"
      >
        {{ snackbartext }}
        <v-btn
          color="pink"
          flat
          style="outline: none;"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import jwtDecode from "jwt-decode";
import { userManager } from "../../config/auth";

export default {
  name: "Login-new",
  beforeCreate() {
    window.analytics.reset();
    sessionStorage.removeItem("user-token");
  },
  data() {
    return {
      showPassword: false,
      state: "1",
      statelogin: true,
      snackbar: false,
      snackbartext: "",
      username: "",
      password: "",
      logonFailure: false,
      logonFailureText: "",
      resetFailure: false,
      resetFailureText: "",
      image: null,
      logo: null,
      logoPartner: null,
      stylelogoPartner: null,
      backgroundPartner: null,
      buttonColor: null,
      logo_width: null,
      logo_height: null,
      forgotPassword: false,
      forgotConfirm: false,
      timetoken: "60m",
      timesession: [
        {
          text: "1 Hour",
          value: "60m"
        },
        {
          text: "24 Hour",
          value: "24h"
        }
      ],
      style: "",
      style_left: "",
      style_right: "",
      image_info: "",
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      style_img_info: "",
      ampid: "",
      loading: true,
      loadingBtn: false,
      external_access: "",
      checkAuth: false,
      checkToken: false,
      redirect: false,
      coundown: 3,
      refreshIntervalId: "",
      isExpired: false
    };
  },
  created() {
    this.external_access = this.$route.query.access;
    if (partner === "inet") {
      this.image = require("../assets/img/bg-green.jpg");
      this.logo = require("../assets/img/login/logo-ilog-256.png");
      this.logoPartner = require("../assets/img/login/inet-logo.png");
      this.stylelogoPartner = "width: 210px; height: 80px;";
      this.image_info = require("../assets/img/login/bg-cyber-3.png");
      this.style_img_info = "width: 440px; height: 300px; ";
      this.buttonColor = "#3EAAC2";
      //   this.logo_width = 50
      //   this.logo_height = 50
      this.backgroundPartner = "background-color: #004D40;";
      //   this.backgroundPartner = 'background-color: #00695C;'
      //   this.backgroundPartner = `background-image: url(${require('../assets/img/login/bg-line-green.jpg')});`
      this.style_left =
        "width: 100%; height: 100%; color: #fff; background-color: #000;";
      this.style_right = `width: 100%; height: 100%;
                background-image: url(${this.image});
                background-position: right;
                background-repeat: no-repeat;
                background-size: cover;
                position: relative;`;
    } else if (partner === "uih") {
      this.image = require("../assets/img/bg-blue.jpg");
      this.logo = require("../assets/img/login/logo-ilog-256.png");
      this.logoPartner = require("../assets/img/login/uih.png");
      this.stylelogoPartner = "width: 200px; height: 100px; margin-left: 25px;";
      this.image_info = require("../assets/img/login/bg-cyber-0.png");
      this.style_img_info = "width: 410px; height: 280px;";
      this.buttonColor = "#3EAAC2";
      //   this.logo_width = 50
      //   this.logo_height = 50
      this.backgroundPartner = "background-color: #37474F;";
      this.style_left =
        "width: 100%; height: 100%; color: #fff; background-color: #000;";
      this.style_right = `width: 100%; height: 100%;
                background-image: url(${this.image});
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                position: relative;`;
    } else if (partner === "demo") {
      this.image = require("../assets/img/login/Rectangle.png");
      this.logo = require("../assets/img/login/logo-ilog-256.png");
      this.image_info = require("../assets/img/login/bg-cyber-0.png");
      this.style_img_info = "width: 410px; height: 280px;";
      this.buttonColor = "#3EAAC2";
      //   this.logo_width = 50
      //   this.logo_height = 50
      //   this.style = 'background-color: #1A237E;'
      this.style_left =
        "width: 100%; height: 100%; color: #fff; background-color: #000;";
      this.style_right = `width: 100%; height: 100%;
                background-image: url(${this.image});
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                position: relative;`;
    } else if (partner === "portal") {
      this.image = require("../assets/img/login/Rectangle.png");
      this.logo = require("../assets/img/login/logo-ilog-256.png");
      this.image_info = require("../assets/img/login/bg-cyber-3.png");
      this.style_img_info = "width: 440px; height: 300px;";
      this.buttonColor = "#3EAAC2";
      this.backgroundPartner = "background-color: #212236;";
      //   this.logo_width = 50
      //   this.logo_height = 50
      //   this.style = 'background-color: #1A237E;'
      //   this.backgroundPartner = `background-image: url(${require('../assets/img/login/bg-line-green2.jpg')});
      //     background-position: center;
      //     background-repeat: no-repeat;
      //     background-size: cover;`
      this.style_left = "color: #fff; background-color: #000;";
      this.style_right = `background-image: url(${this.image});`;
    } else if (partner === "ais") {
      this.image = require("../assets/img/bg-green2.jpg");
      this.logo = require("../assets/img/login/logo-ilog-256.png");
      this.logoPartner = require("../assets/img/login/ais.png");
      this.stylelogoPartner = "width: 210px; height: 80px; margin-left: 30px;";
      this.image_info = require("../assets/img/login/bg-cyber-3.png");
      this.style_img_info = "width: 440px; height: 300px;";
      this.buttonColor = "#3EAAC2";
      // this.logo_width = 45
      // this.logo_height = 45
      this.backgroundPartner = "background-color: #004D40;";
      // this.backgroundPartner = `background-image: url(${require('../assets/img/login/bg-line-green.jpg')}); background-size: cover;`
      this.style_left =
        "width: 100%; height: 100%; color: #fff; background-color: #000;";
      this.style_right = `width: 100%; height: 100%;
                background-image: url(${this.image});
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                position: relative;`;
    }
  },
  async mounted() {
    const handleLogin = user => this.verifyCognitoUser(user);

    userManager.events.addUserLoaded(function(user) {
      console.log("New User Loaded：", arguments);
      console.log("Acess_token: ", user.access_token);
      handleLogin(user);
    });
    if (this.external_access) {
      try {
        let response = await axios.post(apiUrl + "/api/auth/vertifyAccess", {
          token: this.external_access
        });
        if (response.data.success) {
          this.checkToken = true;
          let decode = jwtDecode(response.data.token);
          this.ampid = decode.ampid;
          window.analytics.identify(this.username, decode, {
            integrations: {
              Amplitude: {
                session_id: this.ampid
              }
            }
          });
          setTimeout(() => {
            window.analytics.track(
              "[Login]",
              {
                value: {
                  username: this.username
                }
              },
              {
                integrations: {
                  Amplitude: {
                    session_id: this.ampid
                  }
                }
              }
            );
          }, 300);
          sessionStorage.setItem("user-token", response.data.token);
          sessionStorage.setItem(
            "iLog-search",
            JSON.stringify(response.data.search)
          );
          this.checkAuth = true;
          this.loadingBtn = false;
          this.isExpired = response.data.isExpired;
          this.redirect = true;
        }
      } catch (error) {
        this.snackbar = true;
        this.snackbartext = error;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    } else {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
    userManager.signinRedirectCallback().then(user => {
      this.verifyCognitoUser(user);
    });
    console.log(process.env.AWS_REDIRECT_URI);
  },
  methods: {
    async verifyCognitoUser(user) {
      if (user) {
        const token = user.id_token;

        this.loadingBtn = true;

        try {
          const response = await axios.post(apiUrl + "/api/auth/login", {
            username: this.username || user.profile.email,
            token,
            timetoken: this.timetoken,
            state: "3"
          });

          if (response.data.success) {
            let decode = jwtDecode(response.data.token);
            this.ampid = decode.ampid;
            window.analytics.identify(
              this.username || user.profile.email,
              decode,
              {
                integrations: {
                  Amplitude: {
                    session_id: this.ampid
                  }
                }
              }
            );
            setTimeout(() => {
              window.analytics.track(
                "[Login]",
                {
                  value: {
                    username: this.username || user.profile.email,
                    customer_name: decode.customer_name
                  }
                },
                {
                  integrations: {
                    Amplitude: {
                      session_id: this.ampid
                    }
                  }
                }
              );
            }, 300);
            sessionStorage.setItem("user-token", response.data.token);

            response.data.role !== "AIS_Dashboard"
              ? this.$router.push({
                  name: "dashboard",
                  params: { isExpired: response.data.isExpired }
                })
              : this.$router.push({
                  name: "allDashboard",
                  params: { isExpired: response.data.isExpired }
                });
          }
        } catch (error) {
          this.snackbartext = error;
          this.snackbar = true;
        } finally {
          this.loadingBtn = false;
        }
      }
    },
    async cognitoSignIn() {
      const user = await userManager.signinRedirect();
      this.verifyCognitoUser(user);
    },
    async login() {
      console.log(this.state);
      if (this.state === "1") {
        // let response = await axios.post(apiUrl + '/api/auth/login', {
        //     username: this.username,
        //     state: this.state
        // })
        // // console.log(response.data)
        // if (response.data.success) {
        //     this.statelogin = false
        //     this.logonFailure = false
        //     this.state = '2'
        // } else {
        //     this.logonFailure = true
        //     this.logonFailureText = 'Please enter a valid username or e-mail.'
        //     // this.snackbartext = response.data.msg
        //     // this.snackbar = true
        // }

        if (this.username) {
          this.statelogin = false;
          this.logonFailure = false;
          this.state = "2";
          this.loadingBtn = false;
        } else {
          this.loadingBtn = false;
          this.logonFailure = true;
          this.logonFailureText = "Please enter a valid username or e-mail";
        }
      } else {
        if (!this.password) {
          return (this.logonFailureText = "Please enter a password");
        }
        this.loadingBtn = true;
        let response;
        try {
          response = await axios.post(apiUrl + "/api/auth/login", {
            username: this.username,
            password: this.password,
            timetoken: this.timetoken,
            state: this.state
          });
        } catch (error) {
          this.snackbartext = error;
          this.snackbar = true;
          this.loadingBtn = false;
        }
        if (response.data.name === "verify_mfa") {
          this.cognitoSignIn();
        } else if (response.data.success) {
          let decode = jwtDecode(response.data.token);
          this.ampid = decode.ampid;
          window.analytics.identify(this.username, decode, {
            integrations: {
              Amplitude: {
                session_id: this.ampid
              }
            }
          });
          setTimeout(() => {
            window.analytics.track(
              "[Login]",
              {
                value: {
                  username: this.username,
                  customer_name: decode.customer_name
                }
              },
              {
                integrations: {
                  Amplitude: {
                    session_id: this.ampid
                  }
                }
              }
            );
          }, 300);
          sessionStorage.setItem("user-token", response.data.token);
          this.loadingBtn = false;
          response.data.role !== "AIS_Dashboard"
            ? this.$router.push({
                name: "dashboard",
                params: { isExpired: response.data.isExpired }
              })
            : this.$router.push({
                name: "allDashboard",
                params: { isExpired: response.data.isExpired }
              });
        } else {
          this.loadingBtn = false;
          this.logonFailure = true;
          this.logonFailureText = "Incorrect e-mail or password";
          // this.snackbartext = response.data.msg
          // this.snackbar = true
        }
      }
    },
    async resetPassword() {
      try {
        let response = await axios.post(apiUrl + "/api/auth/forgot_password", {
          username: this.username
        });
        if (response.data.success) {
          this.forgotPassword = false;
          this.forgotConfirm = true;
        }
        this.snackbartext =
          "Please check email or junk mail for reset password";
        this.snackbar = true;
      } catch (error) {
        if (error === "Error: Request failed with status code 422") {
          this.resetFailureText = "This username does not exist in the system";
        } else if (error === "Error: Network Error") {
          this.resetFailureText = "Unable to connect to iLog backend server";
        } else {
          this.resetFailureText = "Authentication failed";
        }
        this.resetFailure = true;
      }
    },
    backToEmail() {
      this.password = "";
      this.state = "1";
      this.statelogin = true;
      this.logonFailure = false;
    },
    resetPw() {
      this.state = "1";
      this.statelogin = true;
      this.forgotPassword = true;
      this.logonFailure = false;
    }
  },
  watch: {
    redirect: function() {
      if (this.redirect) {
        this.refreshIntervalId = setInterval(() => {
          this.coundown -= 1;
        }, 1000);
      }
    },
    coundown: function() {
      if (this.coundown === 0) {
        clearInterval(this.refreshIntervalId);
        setTimeout(() => {
          this.$router.push({
            name: "dashboard",
            params: { isExpired: this.isExpired }
          });
        }, 1000);
      }
    }
  }
};
</script>

<style scoped>
.container-login {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  background-color: #212236;
  margin: 0;
  padding: 0;
  min-height: 700px;
  min-width: 1024px;
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
}

.box-layout {
  /* position: absolute; */
  display: flex;
  flex-direction: row;
  padding: 40px;
  height: 700px;
  width: 98.5%;
  /* margin: 11px 11.5px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1500px;
}

.box-overview {
  width: 100%;
  height: 100%;
  background-color: #1a1a1e;
  border-radius: 8px 0 0 8px;
}

.box-overview > .logo-ilog {
  width: 80px;
  height: 80px;
  margin: 50px auto;
}

.box-overview > h2 {
  color: #fff;
  margin: 50px auto;
  font-size: 28px;
  pointer-events: none;
}

.box-overview > .image_info {
  width: 410px;
  height: 280px;
}

.box-login {
  width: 100%;
  height: 100%;
  border-radius: 0 8px 8px 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.box-login > h2 {
  position: relative;
  top: 40px;
  color: #fff;
  margin: 25px auto;
  font-size: 28px;
  margin-top: 100px;
  pointer-events: none;
}

.session-box {
  margin: 0 auto;
}

.card {
  border-radius: 13px;
  width: 500px;
  height: 330px;
  margin: 0 auto;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}

.ilog-dev {
  position: absolute;
  color: #fff;
  margin: 0 5px;
  bottom: 0;
}

.logo-ragnar {
  position: relative;
  width: 45px;
  height: 45px;
}

#username-login {
  background-color: #44465b;
  /* color: #fff !important; */
  border-radius: 5px;
}

.icon_person {
  color: #dadada !important;
  padding: 0 9px;
  pointer-events: none;
  /* border-right: 1px solid #aaa; */
}

.tab-left {
  width: 8px;
  height: 68px;
  background: #3eaac2;
  border-radius: 5px 0px 0px 5px;
}

.tab-right {
  width: 8px;
  height: 68px;
  background: #3eaac2;
  border-radius: 0px 5px 5px 0px;
  margin-left: 18px;
}

.usernamestate2 {
  width: 270px;
  height: 37px;
  align-self: center;
  background-color: #44465b !important;
}

.usernamestate2 > .text-center {
  padding: 0px !important;
  margin-top: 6px !important;
  margin-left: 8px !important;
  color: #dadada;
}

.back_login {
  padding: 0;
  margin-right: 8px;
  color: #dadada !important;
}

.fail-login {
  width: 250px;
  position: relative;
  margin: 5px 0;
  left: 40px;
  text-align: left;
}

@keyframes slideInFromTop {
  0% {
    transform: translateY(-15%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideInFromLeft {
  0% {
    transform: translateY(5%);
  }
  100% {
    transform: translateY(0);
  }
}

.text-trans {
  animation: 1s ease-out 0s 1 slideInFromTop;
}
.login-trans {
  animation: 0.5s ease-out 0s 1 slideInFromLeft;
}
.btn-ilog-login {
  width: 100%;
}
.timesession {
  margin-left: 40px;
  max-width: 95px;
}
.forgotPW {
  margin-left: 145px;
  padding: 0;
}
.groupResetPW {
  margin-right: 20px;
}
.info-bottom {
  margin: 85px 30px 0 30px;
}
.info-bottom > .version {
  color: #bbb;
  font-size: 12px;
  margin-top: 8px;
  pointer-events: none;
}
@media screen and (max-width: 1264px) {
  .card {
    margin-left: 0px;
  }
  .btn-ilog-login {
    margin-left: 20%;
    width: 93%;
  }
  .session-box {
    margin-left: 16%;
  }
  .usernamestate2 {
    width: 250px;
  }
  .fail-login {
    margin-left: 77px;
  }
  .forgotPW {
    margin-left: 145px;
    max-width: 0;
    background-color: red;
  }
  .groupResetPW {
    margin-left: 140px;
  }
}
@media screen and (max-width: 1140px) {
  .card {
    right: 10%;
  }
  .btn-ilog-login {
    margin-left: 20% !important;
    width: 95%;
  }
  .session-box {
    margin-left: 17%;
  }
}
@media screen and (max-width: 1024px) {
  .box-overview {
    display: none !important;
  }
  /* .container-login {
        left: 50%;
        margin-left: -512px;
    } */
  .box-login {
    max-width: 900px;
    max-height: 900px;
    position: relative;
    left: 2%;
  }
  .card {
    margin-left: 25%;
  }
  .btn-ilog-login {
    margin-left: 10%;
  }
  .session-box {
    margin-left: 16%;
  }
}
@media screen and (max-width: 896px) {
  .info-bottom {
    margin: 85px -50px 0 -50px;
  }
}

.card-loading {
  width: 200px !important;
  height: 200px !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue